var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0018,
    cy: 23.9998,
    r: 20.4545,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.72727
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8199 15.0005C13.5772 16.2431 13.5772 18.2576 14.8199 19.5002L19.3196 24L14.8199 28.4998C13.5772 29.7424 13.5772 31.7569 14.8199 32.9995C16.0625 34.2422 18.077 34.2422 19.3196 32.9995L23.8194 28.4998L28.3192 32.9995C29.5618 34.2422 31.5763 34.2422 32.8189 32.9995C34.0616 31.7569 34.0616 29.7424 32.8189 28.4998L28.3192 24L32.8189 19.5002C34.0616 18.2576 34.0616 16.2431 32.8189 15.0005C31.5763 13.7578 29.5618 13.7578 28.3192 15.0005L23.8194 19.5002L19.3196 15.0005C18.077 13.7578 16.0625 13.7578 14.8199 15.0005Z",
    fill: "#FF4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.bbaa754394c63c136736c55a4c92fd8a.svg";
export { ForwardRef as ReactComponent };